// This file is generated and hand-edited. Source of truth for the "integrations" namespace.
// See docs/locales.md for naming conventions and tooling.

export const integrations = {
  annotations: {
    tools: {
      rectangle: "Rectangle",
      label: "Label",
    },
    table: {
      headers: {
        createdAt: "Created At",
      },
    },
  },
  jitsi: {
    startCall: "Start Call",
    alreadyInMeeting: "You are already in a meeting",
    error: {
      divNotSet: "Already in a meeting or meetingDiv is not set",
    },
  },
} as const;

export type IntegrationsMessages = typeof integrations;
